export const EMPTY_CUSTOMER_LINE_FILTERS = {
    search: "",
    customer: "",
    dateFrom: "",
    dateTo: ""
};

export function customerLineFiltersWithCustomer(customer) {
    return {
        ...EMPTY_CUSTOMER_LINE_FILTERS,
        customer: customer || ""
    };
}
